import styled from 'styled-components';
import 'react-step-progress-bar/styles.css';
import { OnboardingProvider } from '../../contexts/onboarding';
import TrackOnboarding from './Teams/TeamsOnboarding';
import FullScreenModal from '../Modal/Overlay';
import PageWrapper from '../PageWrapper';

const Page = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default function OnboardingModal({
  onboardingTask,
  onClose,
  onRefreshData,
  isRefreshing,
}) {
  return (
    <OnboardingProvider onboardingTask={onboardingTask}>
      <FullScreenModal shouldLockBody={false}>
        <Page>
          <TrackOnboarding
            track={onboardingTask.track}
            onRefreshData={onRefreshData}
            onClose={onClose}
            isRefreshing={isRefreshing}
          />
        </Page>
      </FullScreenModal>
    </OnboardingProvider>
  );
}
